import React, { useEffect, useState, PureComponent } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  AreaChart,
  Area,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { DateRange } from "../../../components/DateRange";
import { sensor } from "../../../api";
import { subMonths, startOfDay, endOfDay, format } from "date-fns";
import {
  formatDateOnly,
  formatDateTime,
  formatTimeOnly,
} from "../../../utils/helper";

class CustomizedAxisTick extends PureComponent {
  render() {
    const { x, y, stroke, payload } = this.props;

    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#fff">
          {formatDateOnly(payload.value)}
        </text>
      </g>
    );
  }
}
function CurrentChart({ sensorData }) {
  console.log({ sensorData });
  const [speedData, setSpeedData] = useState([]);
  const [overview, setOverview] = useState({
    minimum: 0,
    average: 0,
    maximum: 0,
  });
  const [selectedInterval, setSelectedInterval] = useState("Month");
  const [date, setDate] = useState({
    startDate: startOfDay(new Date()),
    endDate: endOfDay(new Date()),
  });
  useEffect(() => {
    if (sensorData) {
      const getData = async () => {
        const measurement = sensorData?.machine_element_name
          .toLowerCase()
          .includes("motor")
          ? "SPEED_MOTOR"
          : "SPEED_BLOWER";
        const machine_element = sensorData?.machine_element_name
          .toLowerCase()
          .includes("motor")
          ? "MOTOR"
          : "BLOWER";
        const result = await sensor.liveSpeed({
          measurement: "CURRENT_64K3",
          machine_element: machine_element,
          start: format(new Date(date?.startDate), "yyyy-MM-dd HH:mm:ss"),
          end: format(new Date(date?.endDate), "yyyy-MM-dd HH:mm:ss"),
        });
        if (result.ok) {
          const body = await result.json();
          let data = body.data;
          const temp = data.map((s) => ({
            date: format(s[0], "yyyy-MM-dd HH:mm:ss"),
            speed: s[1],
          }));
          setSpeedData(temp);
        }
      };

      getData();

      const syncData = setInterval(() => {
        getData();
      }, 45000);

      return () => {
        clearInterval(syncData);
      };
    }
  }, [date, sensorData]);
  const handleChangeDate = (startDate, endDate) => {
    setDate({
      startDate: new Date(startDate),
      endDate: endOfDay(new Date(endDate)),
    });
    setSelectedInterval("Custom");
  };
  const CustomTooltip = ({ active, payload, label }) => {
    //console.log({ active, payload, label });
    if (active && payload && payload.length) {
      return (
        <div style={{ background: "rgba(0,0,0,0.8)", padding: "5px" }}>
          {`Date : ${label}`} <br />
          {`Current : ${parseFloat(payload[0]?.value).toFixed(2)}`} <br />
        </div>
      );
    }

    return null;
  };
  return (
    <>
      <p style={{ textAlign: "left", marginLeft: "50px" }}></p>
      <div className="row justify-content-between mb-4">
        <div className="col-md-4 col-sm-6">
          {/*{[ "Week", "Day"].map((interval) => (*/}
          {/*  <button*/}
          {/*    onClick={() => setSelectedInterval(interval)}*/}
          {/*    className={`btn btn-sm ${*/}
          {/*      interval === selectedInterval*/}
          {/*        ? "btn-theme"*/}
          {/*        : "btn-outline-theme"*/}
          {/*    }`}*/}
          {/*    key={interval}*/}
          {/*  >*/}
          {/*    {interval}*/}
          {/*  </button>*/}
          {/*))}*/}
        </div>
        <div className="col-md-4  col-sm-6">
          <div>
            <DateRange
              onChange={handleChangeDate}
              startDate={date.startDate}
              endDate={date.endDate}
            />
          </div>
        </div>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <AreaChart
          width={500}
          height={300}
          fontSize={13}
          margin={{ left: 0 }}
          data={speedData}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey={"date"}
            tick={<CustomizedAxisTick />}
            tickLine={false}
            height={60}
            label={{
              value: "Date",

              position: "center",
            }}
          />
          <YAxis
            width={90}
            tick={{ fill: "white" }}
            label={{
              value: "Current",
              angle: -90,
              position: "center",
            }}
            tickLine={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            connectNulls={true}
            type={"monotone"}
            dot={false}
            dataKey={"speed"}
            stroke="#ffcd6a"
            fill="#ffcd6a"
            strokeWidth={1}
          />

          {/* TODO: This needs to be refactored */}
        </AreaChart>
      </ResponsiveContainer>
    </>
  );
}
export default CurrentChart;
